/**
 *
 *
 *
 *
 *
 */

window.o_global.eventQBus.on(
  "assets.focusseddialog.init",
  (windowLocationSearch, windowLocationHref, target = document.querySelector("body")) => {
    const prefix = "js-";

    const selectors = {
      closeAttribute: "data-focussed-dialog-close-url",
      prevAttribute: "data-focussed-dialog-prev-url",
      addClose: `.${prefix}pl_focussed-dialog__add-closeUrl`,
      addPrev: `.${prefix}pl_focussed-dialog__add-prevUrl`,
      closeLink: `a.${prefix}pl_focussed-dialog__closeUrl`,
      prevLink: `a.${prefix}pl_focussed-dialog__prevUrl`,
      dialog: `.${prefix}pl_focussed-dialog`,
      hideInApp: `.${prefix}pl_focussed-dialog--hideInApp`,
    };

    const closeQueryName = "focussedDialogCloseUrl";
    const prevQueryName = "focussedDialogPrevUrl";

    const utils = {
      /*                                          */
      getValueFromQueryString: (queryString, parameterName) => {
        const vars = queryString.split("&");
        let res;
        vars.forEach((v) => {
          const equalPosition = v.indexOf("=");
          const value = v.slice(equalPosition + 1);
          const key = v.replace(`=${value}`, "");
          if (key === parameterName) {
            res = value;
          }
        });
        return res;
      },
      getUrlObject: (url) => {
        /*                                                         */
        const a = document.createElement("a");
        a.href = url;

        /*                                                */

        /*                                      */
        a.href = a.href;
        return a;
      },
      encode: (str) => {
        return encodeURIComponent(str);
      },
      decode: (str) => {
        return decodeURIComponent(str);
      },
      createRelativeLink: (url) => {
        const { pathname, search, hash } = utils.getUrlObject(url);
        const relativeUrl = `${pathname.indexOf("/") !== 0 ? "/" : ""}${pathname}${search}${hash}`;
        return relativeUrl;
      },
      getURLwithExtendedSearch: ({ pathname, search, hash, extraParams = "" }) => {
        const extended = `${search ? `${search}&` : "?"}${extraParams}`;

        const newUrl = `${pathname.indexOf("/") !== 0 ? "/" : ""}${pathname}${extended}${hash}`;
        return newUrl;
      },
      appendQueryToElement: (el, url, queryName) => {
        const tagName = el.tagName.toLowerCase();

        const { pathname, search, hash } = utils.getUrlObject(
          el.getAttribute("href") || el.getAttribute("action")
        );
        const extraParams = `${queryName}=${url}`;
        const newUrl = utils.getURLwithExtendedSearch({
          pathname,
          search,
          hash,
          extraParams,
        });

        if (tagName === "a") {
          el.setAttribute("href", newUrl);
          el.removeAttribute("disabled");
        }
        if (tagName === "form") {
          el.setAttribute("action", newUrl);
        }
      },
      /*                     */
      isSafeUrl: (url) => {
        const { host, protocol, port, pathname } = utils.getUrlObject(url);
        let fixedHost = host;
        /**
 *
 */
        if (port === "443" || port === "80") {
          const portInHostnamePos = host.indexOf(":");
          fixedHost = host.slice(0, portInHostnamePos);
        }
        /*                                                                             */
        if (/\/{2,}/g.test(pathname)) {
          /*                                                                                 */
          return false;
        }
        const isSafe = fixedHost === window.location.host && protocol === window.location.protocol;
        /*                                   */
        return isSafe;
      },
    };

    /**
 *
 *
 *
 *
 */

    [].forEach.call(target.querySelectorAll(selectors.dialog), (dialog) => {
      if (window.o_util.cookie.exists("app")) {
        const elementsToHide = dialog.querySelectorAll(selectors.hideInApp);
        dialog.classList.add("pl_focussed-dialog--inApp");

        [].forEach.call(elementsToHide, (el) => {
          /*                                         */
          el.style.display = "none";
        });
      }
    });

    /*                          */
    [].forEach.call(target.querySelectorAll(`a[${selectors.closeAttribute}]`), (el) => {
      const url = el.getAttribute(selectors.closeAttribute) || windowLocationHref;
      utils.appendQueryToElement(el, utils.encode(utils.createRelativeLink(url)), closeQueryName);
    });

    /*                         */
    [].forEach.call(target.querySelectorAll(`a[${selectors.prevAttribute}]`), (el) => {
      const url = el.getAttribute(selectors.prevAttribute) || windowLocationHref;

      utils.appendQueryToElement(el, utils.encode(utils.createRelativeLink(url)), prevQueryName);
    });

    if (windowLocationSearch) {
      const closeLinks = document.querySelectorAll(selectors.closeLink);
      const prevLinks = document.querySelectorAll(selectors.prevLink);

      const prevUrl = utils.getValueFromQueryString(
        windowLocationSearch.substring(1),
        prevQueryName
      );

      const closeUrl = utils.getValueFromQueryString(
        windowLocationSearch.substring(1),
        closeQueryName
      );

      const addCloseElements = document.querySelectorAll(selectors.addClose);
      const addPrevElements = document.querySelectorAll(selectors.addPrev);

      if (prevUrl && utils.isSafeUrl(utils.decode(prevUrl))) {
        [].forEach.call(addPrevElements, (el) => {
          utils.appendQueryToElement(el, prevUrl, prevQueryName);
        });

        /*                                            */
        [].forEach.call(prevLinks, (el) => {
          const extraParams = el.getAttribute("data-focussed-dialog-add-params");
          let url = utils.decode(prevUrl);
          if (extraParams) {
            const { pathname, search, hash } = utils.getUrlObject(url);
            url = utils.getURLwithExtendedSearch({
              pathname,
              search,
              hash,
              extraParams,
            });
          }

          el.setAttribute("href", url);
          el.removeAttribute("disabled");
        });
      }

      /*                                   */
      if (closeUrl && utils.isSafeUrl(utils.decode(closeUrl))) {
        /*                                                                         */
        [].forEach.call(addCloseElements, (el) => {
          utils.appendQueryToElement(el, closeUrl, closeQueryName);
        });

        /*                                                                       */
        [].forEach.call(closeLinks, (el) => {
          const extraParams = el.getAttribute("data-focussed-dialog-add-params");
          let url = utils.decode(closeUrl);
          if (extraParams) {
            const { pathname, search, hash } = utils.getUrlObject(url);
            url = utils.getURLwithExtendedSearch({
              pathname,
              search,
              hash,
              extraParams,
            });
          }

          el.setAttribute("href", url);
          el.removeAttribute("disabled");
        });
      }
    }
  }
);

window.o_global.eventLoader.onReady(10, () => {
  window.o_global.eventQBus.emit(
    "assets.focusseddialog.init",
    window.location.search,
    window.location.href
  );
});
